import { Button } from "@/components/Button"
import { Image } from "@/components/common/Image"
import { ClientType, useBaseUploadForm } from "@usher/pe-client-front-end-lib"
import { FormattedMessage } from "react-intl"

type BaseUploadFormProps = {
  type: string
  client_type?: ClientType
}

const onSuccess = (fileName: string) => {
  return (
    <>
      {fileName} is uploaded.
      <br />
      Your documents have been sent to Verification Department, please wait for the answer from the team manager or contact us via email{" "}
      {process.env.REACT_APP_COMPANY_EMAIL}
    </>
  )
}

export const BaseUploadForm = ({ type, client_type }: BaseUploadFormProps) => {
  const { error, isUploaded, isUploading, onUpload, files, getRootProps, getInputProps, onDelete } = useBaseUploadForm({
    type,
    onSuccess,
    multiple: true,
  })
  const isCorporateAccount = client_type === ClientType.Coroporate
  return (
    <div className="tab-pane fade show active">
      {error !== "" && <p className="application-form__title mb-xs">{error}</p>}
      <h4 className="h4 application-form__upload-title">
        {isCorporateAccount ? <FormattedMessage id={`verif_${Number(type) - 16}`} /> : <FormattedMessage id={`pa_210_${type}`} />}
      </h4>
      <p>{isCorporateAccount ? <FormattedMessage id={`pa_210_${type}`} /> : <FormattedMessage id={`pa_211_${type}`} />}</p>
      <h4 className="h4 application-form__upload-title text-uppercase">
        <FormattedMessage id="pa_198" />
      </h4>
      <ul className="list application-form__upload-list">
        <li className="application-form__upload-item">
          <FormattedMessage id="pa_199" />
        </li>
        <li className="application-form__upload-item">
          <FormattedMessage id="pa_200" />
        </li>
        <li className="application-form__upload-item">
          <FormattedMessage id="pa_201" />
        </li>
        <li className="application-form__upload-item">
          <FormattedMessage id="pa_202" />
        </li>
      </ul>
      {isUploading && (
        <div className="spinner-border centered">
          <span className="sr-only">Uploading...</span>
        </div>
      )}
      {isUploaded && <strong className="alert alert-success">File has been uploaded!</strong>}
      {!isUploading && !isUploaded && (
        <>
          <p className="application-form__upload-des">
            <FormattedMessage id="pa_203" />
          </p>
          {/* @ts-ignore */}
          <div
            {...getRootProps({
              className: "dropzone application-form__upload-box d-flex",
            })}
          >
            {files.map((file, key) => (
              <div key={key} className="application-form__upload-uploaded">
                <img src={file.preview ?? ""} className="img-fluid" alt="" />
                <button
                  className="button-reset application-form__upload-delete"
                  onClick={(e) => {
                    e.stopPropagation()
                    e.preventDefault()
                    onDelete(file)
                  }}
                >
                  <Image src="delete_i.svg" />
                </button>
              </div>
            ))}
            <input onClick={(e) => e.stopPropagation()} {...getInputProps()} />
            <div className="application-form__upload-field">
              <label className="application-form__upload-label">
                <Image src="add.svg" className="application-form__upload-add" />
                <span className="application-form__upload-helps d-block px-2">
                  <FormattedMessage id="pa_204_1" />
                  <span>
                    <FormattedMessage id="pa_204_2" />
                  </span>
                </span>
              </label>
            </div>
          </div>
          <div className="aplication-form">
            <div className="aplication-form__buttons d-flex justify-content-end">
              <Button onClick={onUpload}>
                <FormattedMessage id="pa_205" />
              </Button>
            </div>
          </div>
        </>
      )}
    </div>
  )
}
